<template>
	<div ref="error-container" class="message-panel-errors">
		<!-- <template v-for="(error, key) in $parent.errors" v-if='key == type'> -->
		<template v-for="(error, key) in errors2" >
            <template v-if='key.match(new RegExp(type))'>
				<p :key='key + ":" + index' class="_error alert alert-warning" v-for="(message, index) in error">
					<span v-html='autobrand(message).replace("RESET_LINK", "/#/password-reset/Profile")'></span>
				</p>
            </template>
		</template>
	</div>
</template>

<script>
	/**
	 * Message types:
	 *
	 * success
	 * info
	 * warning
	 * danger
	 */

	export default {
		props: {
			"type": {},
			"errors": {
				default: null
			}
		},
		data: function(){
			return {
			};
		},
		computed: {
			errors2() {
				if(this.errors) {
					return this.errors;
				}
				else {
					return this.$parent.errors;
				}
			}
		},
		mounted() {
		},
		methods: {
		}
    }
</script>
